<script>
  import {modalState, showModal} from '@app/store/modalStore.svelte.js';
  import {projectState} from '@app/store/projectStore.svelte.js'
  import {
    eventGroupState
} from '@app/store/eventGroupStore.svelte.js';
import {authState} from '@app/store/authStore.svelte.js';
import {
    environment
} from '@app/store/envStore.svelte.js';
  //IMPORT sWAL
  import Swal from "sweetalert2";
  import { SWAL_BASE, SWAL_CLASSES } from "@app/lib/swalClasses.js";
  import * as m from '@app/paraglide/messages.js';
  
/** @type {{currentState: boolean, toggleMenu: (menu: string) => void}} */
let { currentState, toggleMenu } = $props();
  
function handleToggleMenu(){
    toggleMenu('aiTools');
}

function renderAllAudioEvents(){
    /* Use SweetAlert to Ask the user if they are sure they want to render all audio events, and then select all events, and open the Render audio modal. */
    Swal.fire({
        ...SWAL_BASE,
        customClass: SWAL_CLASSES.confirmCancel,
        title: m.are_you_sure(),
        text: m.are_you_sure_render_all(),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: m.yes(),
        cancelButtonText: m.cancel(),
    }).then((result) => {
        if (result.isConfirmed) {
            eventGroupState[projectState.selected].selected = eventGroupState[projectState.selected].events.map((event, count)=>{
                return count;
            });
            
            showModal("renderAudio");            
        }
    });
    
}
</script>
<li class="nav-item dropdown {currentState ? 'show' : ''}" role="menuitem">
  <a onclick={handleToggleMenu} class="dropdown-toggle nav-link" href="#!/" id="aiToolsMenu" aria-haspopup="true" aria-expanded={currentState}>{m.ai_tools()}</a>
  <div class="dropdown-menu {currentState ? 'show' : ''}" role="menu" aria-labelledby="aiToolsMenu">
    {#if (authState.plan === 'pro' || authState.plan === 'enterprise') && authState.type === "default" && authState.status !== "in_trial" && environment.online}
        <a class="dropdown-item" href="#!/" role="menuitem" id="batchTranscriptionBtn" onclick={() => showModal("batchTranscription")}>{m.batch_transcription()}</a>
        <hr class="dropdown-divider">
    {/if}
    {#if environment.online}
        <a class="dropdown-item {(!projectState.media.path || projectState.media.storage === "HLS Manifest" || projectState.media.storage === "Vimeo") && projectState.media.storage !== "Proxy RT" ? 'disabled' : ''}" href="#!/" onclick={() => showModal("automaticTranscription")}>{m.automatic_transcription()}</a>
    {/if}
    {#if (authState.plan === 'pro' || authState.plan === 'enterprise') && environment.online}
        <a class="dropdown-item {!eventGroupState[projectState.selected] ? 'disabled' : ''}" href="#!/" onclick={() => showModal("automaticTranslation")}>{m.automatic_translation()}</a>
    {/if}
    {#if authState.ad && environment.electron && environment.online}
        <a class="dropdown-item {!projectState.media.path || (projectState.media.storage !== 'Local Storage' && projectState.media.storage !== 'Cloud Storage') ? 'disabled' : ''}" href="#!/" onclick={() => showModal("automaticAd")}>{m.automatic_ad()}</a>
    {/if}
    {#if (authState.plan === 'pro' || authState.plan === 'enterprise') && environment.electron && environment.online}
        <a class="dropdown-item {!projectState.media.path || (projectState.media.storage !== 'Local Storage' && projectState.media.storage !== 'Cloud Storage') ? 'disabled' : ''}" href="#!/" onclick={() => showModal("automaticSceneDescriptions")}>{m.automatic_scene_descriptions()}</a>
    {/if}
    {#if environment.electron}
        <hr class="dropdown-divider">
        <a class="dropdown-item {!projectState.media.localPath ? 'disabled' : ''}" href="#!/" onclick={() => showModal("sceneChangeDetection")}>{m.detect_shot_changes()}</a>
        <a class="dropdown-item {!projectState.media.localPath ? 'disabled' : ''}" href="#!/" onclick={() => showModal("ocrMedia")}>{m.ocr_media()}</a>
        {#if environment.windows}
            <hr class="dropdown-divider">
            <a class="dropdown-item {!projectState.media.localPath ? 'disabled' : ''}" href="#!/" onclick={() => showModal("offlineTranscription")}>{m.offline_transcription()}</a>
            <a class="dropdown-item {!projectState.media.localPath ? 'disabled' : ''}" href="#!/" onclick={() => showModal("offlineSync")}>{m.offline_sync()}</a>
        {/if}
    {/if}
    {#if (authState.ad && environment.online) || environment.adLicense}
        <hr class="dropdown-divider">
        <a class="dropdown-item {!eventGroupState[projectState.selected] || eventGroupState[projectState.selected].type !== 'audio description' ? 'disabled' : ''}" href="#!/" onclick={() => showModal("renderAudio")}>{m.force_render_audio()}</a>
        <a class="dropdown-item {!eventGroupState[projectState.selected] || eventGroupState[projectState.selected].type !== 'audio description' ? 'disabled' : ''}" href="#!/" onclick={() => renderAllAudioEvents()}>{m.force_render_all_audio()}</a>
    {/if}
    {#if environment.online}
        <hr class="dropdown-divider">
        <a class="dropdown-item" href="#!/" role="menuitem" id="aiTranscriptImportBtn" onclick={() => showModal("aiTranscriptImport")}><i class="bi bi-file-text" aria-hidden="true"></i> {m.transcription_import()}</a>
        {#if authState.plan === 'pro' || authState.plan === 'enterprise'}
            <a class="dropdown-item" href="#!/" onclick={() => showModal("aiTranslationImport")}><i class="bi bi-translate"></i> {m.translation_import()}</a>
        {/if}
        {#if authState.ad}
            <a class="dropdown-item" href="#!/" onclick={() => showModal("aiAdImport")}><i class="bi bi-eye"></i> {m.ad_import_dashboard()}</a>
        {/if}
        {#if authState.plan === 'pro' || authState.plan === 'enterprise'}
            <a class="dropdown-item" href="#!/" onclick={() => showModal("aiSceneDescriptionImport")}><i class="bi bi-camera-reels"></i> {m.scene_description_import_dashboard()}</a>
        {/if}
    {/if}
  </div>
</li>